import React from 'react';

const Blog = () => {
  const blogs = [
    {
      id: 1,
      tag: 'Growth Strategy',
      tagColor: 'text-indigo-400 border-indigo-500/20 bg-indigo-500/5',
      title: 'The Scale Blueprint: Moving Beyond Traditional Frameworks',
      desc: 'An analysis on how next-generation platforms adapt their distribution funnels to acquire global audience segments efficiently without escalating processing costs.',
      date: 'June 08, 2026',
      time: '5 min read'
    },
    {
      id: 2,
      tag: 'Automation',
      tagColor: 'text-teal-400 border-teal-500/20 bg-teal-500/5',
      title: 'Maximizing Content Value Through Dual Distribution Channels',
      desc: 'Why mirroring your broadcast newsletters to a live web dashboard boosts user interaction scores, establishes high SEO footprints, and maintains strong brand equity.',
      date: 'May 28, 2026',
      time: '4 min read'
    },
    {
      id: 3,
      tag: 'Engineering',
      tagColor: 'text-purple-400 border-purple-500/20 bg-purple-500/5',
      title: 'Tuning Low-Latency Frontend Systems for Modern Web Layouts',
      desc: 'A technical deep-dive into optimizing asset pipelines, structural container components, and dynamic routing logic inside high-volume rendering profiles.',
      date: 'May 15, 2026',
      time: '7 min read'
    }
  ];

  return (
    <div className="bg-slate-950 text-slate-100 min-h-screen font-sans antialiased py-24 relative overflow-hidden">
      <div className="absolute top-0 right-1/4 w-96 h-96 bg-indigo-600/5 rounded-full blur-3xl pointer-events-none" />

      <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 relative z-10">
        
        {/* PAGE HEADER */}
        <div className="border-b border-slate-900 pb-12 mb-16">
          <h1 className="text-4xl font-black text-white sm:text-6xl tracking-tight">
            The MoreView <span className="bg-gradient-to-r from-indigo-400 to-sky-400 bg-clip-text text-transparent">Journal</span>
          </h1>
          <p className="mt-4 text-slate-400 text-lg sm:text-xl max-w-2xl font-medium leading-relaxed">
            Insight streams, strategy archives, and production breakdowns delivered directly from our central network pipeline.
          </p>
        </div>

        {/* FEED LIST */}
        <div className="space-y-12">
          {blogs.map((post) => (
            <article 
              key={post.id}
              className="group bg-slate-900/30 border border-slate-900/60 rounded-2xl p-6 sm:p-8 hover:border-slate-800 transition-all cursor-pointer shadow-xl flex flex-col md:flex-row gap-6 items-start justify-between"
            >
              <div className="flex-1">
                <div className="flex items-center gap-3 text-xs mb-4">
                  <span className={`px-2.5 py-1 rounded-md border text-[11px] font-bold uppercase tracking-wider ${post.tagColor}`}>
                    {post.tag}
                  </span>
                  <span className="text-slate-500 font-medium">{post.date}</span>
                </div>
                <h2 className="text-2xl font-extrabold text-white group-hover:text-indigo-400 transition-colors leading-snug">
                  {post.title}
                </h2>
                <p className="text-slate-400 text-sm sm:text-base mt-3 leading-relaxed font-medium">
                  {post.desc}
                </p>
              </div>
              
              <div className="pt-2 md:pt-0 shrink-0 w-full md:w-auto flex items-center justify-between md:justify-end gap-4 text-xs font-bold border-t border-slate-900 md:border-0 mt-4 md:mt-0">
                <span className="text-slate-500 md:hidden">{post.time}</span>
                <span className="bg-slate-900 border border-slate-800 text-slate-300 group-hover:bg-indigo-600 group-hover:text-white group-hover:border-indigo-600 px-4 py-2 rounded-xl transition-all flex items-center gap-1">
                  Read Log <span>→</span>
                </span>
              </div>
            </article>
          ))}
        </div>

        {/* SUBSCRIPTION CAPTURE */}
        <div className="mt-20 bg-gradient-to-b from-slate-900 to-slate-950 border border-slate-800 p-8 rounded-3xl text-center max-w-3xl mx-auto shadow-2xl">
          <h3 className="text-xl font-bold text-white">Get new insights ahead of the curve</h3>
          <p className="text-slate-400 text-sm mt-2 max-w-md mx-auto">Sign up to receive full editions straight to your inbox before they are archived onto the website.</p>
          <div className="mt-6 max-w-md mx-auto flex gap-2">
            <input type="email" placeholder="Your email address" className="bg-slate-950 border border-slate-800 text-xs px-4 py-3 rounded-xl focus:outline-none flex-grow" />
            <button className="bg-indigo-600 text-white font-bold text-xs px-5 py-3 rounded-xl hover:bg-indigo-500 transition-colors">Subscribe</button>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Blog;
